const actions = {
  SET_STATE: "block/SET_STATE",
  LIST: "block/LIST",
  ADD: "block/ADD",
  DETAIL: "block/DETAIL",
  UPDATE: "block/UPDATE",
  DELETE: "block/DELETE",
};

export default actions;
